// extracted by mini-css-extract-plugin
module.exports = {"Grid":"SimpleGrid_Grid__LTmkP","Value":"SimpleGrid_Value__3ItPN"};